(function () {
  'use strict';
  /*
    Verrou « pack atomique » — OutDare.

    Un pack = une ligne prix (produit pack, _pack_size) + ses composants réels
    (_pack), tous marqués du même _pack_id. Le tout forme un bloc indivisible.

    1) GARDE-FOU : toute altération d'un pack (retrait/édition d'un composant,
       retrait de la ligne prix) fait sauter le pack ENTIER. On ne laisse jamais
       l'état à moitié cassé (179 € + composants repassés en remise volume). Il
       agit sur l'ÉTAT du panier (/cart.js + /cart/update.js), donc il tient même
       si Moon Bundle change son HTML.
    2) COSMÉTIQUE : on masque les lignes composants dans le tiroir Moon Bundle,
       on verrouille la quantité de la ligne pack et on corrige le compteur.
    3) PRIX AFFICHÉS : des cans OutDare ajoutées à côté d'un pack sont offertes
       par Shopify à la place de celles du pack ; on remet chaque montant sur la
       ligne qui le doit, dans le tiroir et sur /cart (voir pricePlan).

    RÉVEIL — on n'interroge PAS le panier en boucle. Un pack ne peut se casser
    qu'au moment d'une ÉCRITURE panier (/cart/add|change|update|clear) : on
    enveloppe fetch et XMLHttpRequest pour être prévenu à l'instant où l'une
    aboutit, sans toucher ni à la requête ni à la réponse. Un visiteur sans pack
    au panier ne coûte rien : une seule lecture au chargement, puis plus rien
    tant qu'aucune écriture n'arrive, et aucun observateur DOM.
  */

  var CART = { items: [] };
  var hasPack = false;      // un pack est-il au panier (dernier état connu) ?
  var busy = false;

  // Racine de locale (/fr, /de…) : le thème sert /fr/cart.js, pas /cart.js.
  var ROOT = (function () {
    var m = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return m.replace(/\/$/, '');
  })();
  function cartUrl(p) { return ROOT + '/cart' + p; }

  function getCart() {
    return fetch(cartUrl('.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { CART = c; return c; });
  }

  function groups(cart) {
    var g = {};
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (!p._pack_id) return;
      var grp = g[p._pack_id] || (g[p._pack_id] = { keys: [], header: 0, size: 0, sum: 0 });
      grp.keys.push(it.key);
      if (p._pack_size) { grp.header += it.quantity; grp.size = parseInt(p._pack_size, 10) || 0; }
      else if (p._pack) { grp.sum += it.quantity; }
    });
    return g;
  }

  function broken(grp) { return grp.header !== 1 || grp.size === 0 || grp.sum !== grp.size; }

  function heal(cart) {
    if (busy) return Promise.resolve(false);
    var g = groups(cart), kill = [];
    Object.keys(g).forEach(function (id) { if (broken(g[id])) kill = kill.concat(g[id].keys); });
    if (!kill.length) return Promise.resolve(false);
    busy = true;
    var updates = {};
    kill.forEach(function (k) { updates[k] = 0; });
    return fetch(cartUrl('/update.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json(); })
      .then(function (c) { CART = c; toast(); return true; })
      .catch(function () { return false; })
      .then(function (r) { busy = false; return r; });
  }

  function toast() {
    var t = document.getElementById('od-pack-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'od-pack-toast';
      t.setAttribute('role', 'status');
      t.style.cssText = 'position:fixed;z-index:100000;left:50%;bottom:24px;transform:translateX(-50%);' +
        'background:#1e183e;color:#fff;padding:12px 18px;border-radius:12px;' +
        'font:600 14px/1.35 system-ui,-apple-system,sans-serif;box-shadow:0 8px 30px rgba(0,0,0,.28);' +
        'max-width:90vw;text-align:center;opacity:0;transition:opacity .35s';
      document.body.appendChild(t);
    }
    t.textContent = 'A pack is all-or-nothing — rebuild it on the pack page to change the mix.';
    requestAnimationFrame(function () { t.style.opacity = '1'; });
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.style.opacity = '0'; }, 4200);
  }

  // ── prix affichés : chaque montant sur la ligne qui le doit ──────────────
  // La remise d'un pack (BxGy « OutDare Pack 30/60 — contents included »,
  // 100 % sur 30/60 cans de la collection cible OutDare) ne sait rien de nos
  // propriétés _pack : quand le client ajoute des cans OutDare au même prix que
  // celles du pack (Rad Mint 6/12 mg, Energy), Shopify offre SES cans et fait
  // payer autant de cans du pack, au palier OutDare. Le total est juste, mais la
  // ligne qui porte le prix est une ligne composant — cachée dans le tiroir : le
  // client y lisait « Rad Mint ×11 — 0,00 € ». L'ordre d'ajout n'y change rien.
  // On ne touche pas au panier : la part payée des composants est reportée, à
  // l'affichage, sur les lignes du client que la remise du pack a vidées (au
  // prorata de ce qu'elle leur a offert), et les composants s'affichent à 0.
  // Rend { clé de ligne: { cents, label, off } } ; vide si rien n'a glissé.
  var PACK_TITLE = /contents included|OutDare Pack/i;
  function pricePlan(cart) {
    var items = cart.items || [], titleOf = {}, packTitles = {}, plan = {};
    var leak = 0, tier = '', recips = [], weight = 0;
    function allocs(it) { return it.line_level_discount_allocations || []; }
    function isPackTitle(t) { return !!packTitles[t] || PACK_TITLE.test(t); }
    // La ligne prix d'un pack porte la remise de son pack (à 0 €) : c'est d'elle
    // qu'on tient le titre exact de chaque remise pack au panier.
    items.forEach(function (it) {
      var p = it.properties || {}, a = allocs(it)[0];
      if (p._pack_size && a) packTitles[titleOf[p._pack_id] = a.discount_application.title] = 1;
    });
    items.forEach(function (it) {
      var p = it.properties || {};
      if (p._pack && it.final_line_price > 0) {
        leak += it.final_line_price;
        allocs(it).forEach(function (a) { if (!tier && !isPackTitle(a.discount_application.title)) tier = a.discount_application.title; });
      } else if (!p._pack_id) {
        var w = 0;
        allocs(it).forEach(function (a) { if (isPackTitle(a.discount_application.title)) w += a.amount; });
        if (w > 0) { recips.push({ it: it, w: w }); weight += w; }
      }
    });
    if (!leak || !weight) return plan;
    var left = leak;
    recips.forEach(function (r, i) {
      var share = i === recips.length - 1 ? left : Math.round(leak * r.w / weight);
      left -= share;
      var cents = r.it.final_line_price + share;
      plan[r.it.key] = { cents: cents, label: tier, off: r.it.original_line_price - cents };
    });
    items.forEach(function (it) {
      var p = it.properties || {};
      if (p._pack && it.final_line_price > 0) {
        plan[it.key] = { cents: 0, label: titleOf[p._pack_id] || '', off: it.original_line_price };
      }
    });
    return plan;
  }

  // Format de la boutique, « {{amount_with_comma_separator}}€ » : 1.234,56€.
  // Écrit en euros comme le reste du panier ; darepouch-currency-display.js le
  // convertit ensuite pour les visiteurs GBP/USD/CAD/AUD, comme les prix de Moon.
  function eur(c) {
    var s = (Math.abs(c) / 100).toFixed(2).split('.');
    return (c < 0 ? '-' : '') + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + s[1] + '€';
  }

  // Tiroir : sur une ligne du client que le pack a vidée, le prix de Moon et son
  // badge sont masqués et doublés des nôtres (Moon garde ses nœuds à jour, on ne
  // les réécrit jamais) ; l'icône cadeau part. Une ligne qui ne l'est plus — ou
  // dont Moon a réutilisé le nœud pour une autre — retrouve les siens.
  function paintDrawerItem(item, fix) {
    var price = item.querySelector('.moonbundle-cart-item-price');
    var badge = item.querySelector('.moonbundle-free-gift-badge:not(.od-pack-badge)');
    var gift = item.querySelector('.moonbundle-cart-item-gift-icon');
    var myPrice = item.querySelector('.od-pack-price'), myBadge = item.querySelector('.od-pack-badge');
    if (!fix) {
      if (!item.dataset.odPriced) return;
      delete item.dataset.odPriced;
      if (myPrice) myPrice.remove();
      if (myBadge) myBadge.remove();
      [price, badge, gift].forEach(function (el) { if (el) el.style.display = ''; });
      return;
    }
    item.dataset.odPriced = '1';
    if (price) {
      if (!myPrice) {
        myPrice = document.createElement('p');
        myPrice.className = 'moonbundle-cart-item-price od-pack-price';
        price.parentNode.insertBefore(myPrice, price.nextSibling);
      }
      if (myPrice.dataset.odCents !== String(fix.cents)) {
        myPrice.dataset.odCents = String(fix.cents);
        myPrice.textContent = eur(fix.cents);
      }
      if (price.style.display !== 'none') price.style.display = 'none';
    }
    if (badge) {
      if (fix.label && !myBadge) {
        myBadge = badge.cloneNode(true);
        myBadge.classList.add('od-pack-badge');
        myBadge.style.display = '';
        badge.parentNode.insertBefore(myBadge, badge.nextSibling);
      }
      if (myBadge) {
        var span = myBadge.querySelector('span');
        if (span && span.textContent !== fix.label) span.textContent = fix.label;
      }
      if (badge.style.display !== 'none') badge.style.display = 'none';
    }
    if (gift && gift.style.display !== 'none') gift.style.display = 'none';
  }

  // Page /cart (section main-cart du thème) : toutes les lignes y sont visibles ;
  // on y pose les mêmes montants, total de ligne et étiquette de remise. Le thème
  // remplace le formulaire entier à chaque changement : un nœud neuf n'a pas notre
  // marque, on repeint.
  function paintCartPage(plan) {
    document.querySelectorAll('#AjaxCartForm .cart-form-item[data-id]').forEach(function (row) {
      var fix = plan[row.getAttribute('data-id')];
      if (!fix || row.dataset.odCents === String(fix.cents)) return;
      row.dataset.odCents = String(fix.cents);
      row.querySelectorAll('.cart-item__total strong, .cart-item__price .element--hide-on-desk strong').forEach(function (el) {
        el.textContent = eur(fix.cents);
      });
      var pill = row.querySelector('.cart-item__discounts .pill__label');
      if (pill && fix.label) pill.textContent = fix.label + ' (-' + eur(fix.off) + ')';
    });
  }

  // Affichage « juste la ligne pack » : dans le tiroir, on MASQUE les lignes
  // cannettes (elles roulent avec la commande pour Europesnus, mais restent
  // invisibles au client) ; on garde l'en-tête pack (179 €, barré 294 €),
  // quantité verrouillée à 1 ; et on masque la ligne récap de remise (qui
  // additionnait la valeur des cannettes offertes et gonflait le total).
  function lockDrawer() {
    var drawer = document.querySelector('moonbundle-cart-drawer-block');
    var comp = {}, header = {}, compQty = 0;
    (CART.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (!p._pack_id) return;
      if (p._pack_size) header[it.key] = true;
      else if (p._pack) { comp[it.key] = true; compQty += it.quantity; }
    });

    // Compteur corrigé : un pack compte pour 1, pas pour ses 30/60 cannettes cachées.
    // (S'applique même tiroir fermé — le badge du header est visible partout.)
    if (hasPack) {
      var corrected = String(Math.max(0, (CART.item_count || 0) - compQty));
      document.querySelectorAll('.moonbundle-cart-drawer-header-item-count, [data-header-cart-count]').forEach(function (el) {
        if ((el.textContent || '').trim() !== corrected) el.textContent = corrected;
      });
    }

    // Prix reportés (pricePlan) : /cart et lignes visibles du tiroir. Sans pack, le
    // plan est vide et ne fait que rendre à Moon les lignes qu'on avait repeintes.
    // Sous try : un raté ici ne doit jamais empêcher de masquer les composants.
    try {
      var plan = hasPack ? pricePlan(CART) : {};
      paintCartPage(plan);
      if (drawer) drawer.querySelectorAll('.moonbundle-cart-item[data-item-key]').forEach(function (item) {
        var key = item.getAttribute('data-item-key');
        paintDrawerItem(item, comp[key] ? null : plan[key]);
      });
    } catch (e) {}

    if (!drawer || !hasPack) return;

    // Barre de paliers volume : trompeuse sur un panier pack (les cannettes du pack
    // ne prennent pas la remise volume), on la masque.
    drawer.querySelectorAll('.moonbundle-cart-progress-bar').forEach(function (el) { el.style.display = 'none'; });

    drawer.querySelectorAll('[data-item-key]').forEach(function (node) {
      var key = node.getAttribute('data-item-key');
      var item = node.closest('.moonbundle-cart-item') || node.closest('[class*="cart-item-details"]');
      if (!item) return;
      if (comp[key]) { item.style.display = 'none'; item.dataset.odHidden = '1'; }
      else if (header[key] && !item.dataset.odLocked) {
        item.dataset.odLocked = '1';
        var qc = item.querySelector('.moonbundle-cart-item-quantity-container') || item.querySelector('[class*="quantity-container"]');
        if (qc) qc.style.display = 'none';
        var gift = item.querySelector('[class*="gift"],[class*="bogo"],[class*="Gift"]');
        if (gift) gift.style.display = 'none';
      }
    });
    // Masque la rangée récap de remise (« Save … OutDare Pack … »), ciblée précisément
    // (pas le footer, qui porte le bouton checkout).
    drawer.querySelectorAll('.moonbundle-cart-drawer-discount-line').forEach(function (el) {
      if (/OutDare Pack|contents included/i.test(el.textContent || '')) el.style.display = 'none';
    });
  }

  var relockT;
  function relock() { clearTimeout(relockT); relockT = setTimeout(lockDrawer, 60); }

  // ── observateur : uniquement quand un pack est au panier ────────────────
  // Moon Bundle re-rend son tiroir à chaque changement ; sans cela les lignes
  // cannettes réapparaîtraient. On cible le tiroir dès qu'il existe (sinon le
  // body, le temps qu'il soit monté), et on débranche quand le pack s'en va :
  // un visiteur sans pack ne paie aucun coût d'observation. Sur /cart, on suit
  // aussi le formulaire du thème, qu'il remplace en entier à chaque changement.
  var obs = new MutationObserver(relock), obsOn = [];
  function syncObserver() {
    var targets = [];
    if (hasPack) {
      targets.push(document.querySelector('moonbundle-cart-drawer-block') || document.body);
      var form = document.getElementById('AjaxCartForm');
      if (form && targets[0] !== document.body) targets.push(form);
    }
    if (targets.length === obsOn.length && targets.every(function (t, i) { return t === obsOn[i]; })) return;
    obs.disconnect();
    obsOn = targets;
    targets.forEach(function (t) { obs.observe(t, { childList: true, subtree: true }); });
  }

  // ── réveil sur écriture panier ──────────────────────────────────────────
  var WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  function isWrite(url) {
    try { return WRITE.test(String(url)); } catch (e) { return false; }
  }

  // On enveloppe fetch/XHR sans lire le corps des réponses (le lire le
  // consommerait pour l'appelant) : on note juste qu'une écriture a abouti.
  // Moon Bundle réassigne parfois window.fetch après nous — d'où ensurePatched(),
  // une simple comparaison de référence rejouée aux moments utiles.
  function ensurePatched() {
    var f = window.fetch;
    if (f && !f.__odPack) {
      // Ce wrapper tourne sur TOUTES les pages et pour toutes les requêtes du
      // site : il rend la promesse d'origine telle quelle, ne lit jamais le
      // corps de la réponse (le lire le consommerait pour l'appelant) et ne
      // peut pas faire échouer un appel — notre observation vit dans sa propre
      // branche, sous try.
      var wrapped = function (input) {
        var p = f.apply(this || window, arguments);
        try {
          var url = (input && input.url) || input;
          if (isWrite(url) && p && p.then) p.then(function () { kick(url); }, function () {});
        } catch (e) {}
        return p;
      };
      wrapped.__odPack = true;
      try { window.fetch = wrapped; } catch (e) {}
    }
    var X = window.XMLHttpRequest;
    if (X && X.prototype && !X.prototype.__odPack) {
      var open = X.prototype.open, send = X.prototype.send;
      X.prototype.open = function (m, u) { this.__odUrl = u; return open.apply(this, arguments); };
      X.prototype.send = function () {
        var self = this;
        try {
          if (isWrite(self.__odUrl)) self.addEventListener('loadend', function () { kick(self.__odUrl); });
        } catch (e) {}
        return send.apply(this, arguments);
      };
      X.prototype.__odPack = true;
    }
  }

  // Un pack peut APPARAÎTRE sur un /cart/add ; sinon, sans pack connu au panier,
  // il n'y a rien à vérifier et on ne relit pas le panier.
  var kickT;
  function kick(url) {
    ensurePatched();
    if (!hasPack && url && !/\/cart\/add/.test(String(url))) return;
    clearTimeout(kickT);
    kickT = setTimeout(check, 80);
  }

  function check() {
    return getCart().then(function (cart) {
      hasPack = (cart.items || []).some(function (it) { return (it.properties || {})._pack_id; });
      return heal(cart).then(function (healed) {
        if (healed) hasPack = (CART.items || []).some(function (it) { return (it.properties || {})._pack_id; });
        syncObserver();
        relock();
      });
    }).catch(function () {});
  }

  window.addEventListener('od-pack-added', function () { kick('/cart/add'); });
  window.addEventListener('moonbundle-cart-updated', function () { kick('/cart/add'); });
  document.addEventListener('cart:updated', function () { kick('/cart/add'); });
  // Écritures de dp-metal-can-gift.js et dp-gift-codes.js, faites hors de window.fetch.
  document.addEventListener('dp:cart-changed', function () { kick('/cart/add'); });
  // Un autre onglet a pu toucher au panier pendant qu'on était masqué.
  document.addEventListener('visibilitychange', function () { if (!document.hidden) kick('/cart/add'); });

  function start() {
    ensurePatched();
    check();
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
